import { PureComponent } from "react";
import classnames from "classnames";
import ParagraphWithLogosComponent from "/components/core/paragraph-with-logos/paragraph-with-logos-component";
import SignupWithAnimationComponent from "../signup-with-animation/signup-with-animation-component";
import { StyledCompaniesLogosComponent } from "./companies-logos-component.scss";
import { getCompaniesAssets } from "segments/desktop/core-components/logos/logos-const";

const NUMBER_OF_COMPANIES = 7;

export default class CompaniesLogosComponent extends PureComponent {
  renderSignupWithAnimationIfNeeded() {
    let { withAnimation, signupForm = {}, showSignup } = this.props;
    signupForm.showDecorations = false;

    return (
      showSignup && (
        <div className="signup-wrapper">
          <SignupWithAnimationComponent withAnimation={withAnimation} signupForm={signupForm} />
        </div>
      )
    );
  }

  render() {
    const companiesAssets = getCompaniesAssets();
    const companiesAssetsSliced = companiesAssets.slice(0, NUMBER_OF_COMPANIES);
    return (
      <StyledCompaniesLogosComponent className="companies-with-logos-component">
        <div className={classnames("paragraph-with-logos-wrapper")}>
          <ParagraphWithLogosComponent {...this.props} assets={companiesAssetsSliced} />
        </div>
        {this.renderSignupWithAnimationIfNeeded()}
      </StyledCompaniesLogosComponent>
    );
  }
}

CompaniesLogosComponent.defaultProps = {
  paragraph: {
    title: "Join more than 330,000 users who manage teams better.",
    textDirection: "center"
  },
  signupForm: {},
  withAnimation: true,
  showSignup: true
};
